export default __webpack_public_path__ + "static/media/rizado-negro.c3267739.png";